import { render, staticRenderFns } from "./ticket-details.vue?vue&type=template&id=a40ca166&scoped=true&"
import script from "./ticket-details.vue?vue&type=script&lang=js&"
export * from "./ticket-details.vue?vue&type=script&lang=js&"
import style0 from "./ticket-details.vue?vue&type=style&index=0&id=a40ca166&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40ca166",
  null
  
)

export default component.exports